import Body from "./Body";

export const instance = new Body();

export default { instance };
